import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import last from 'lodash/last';

const getIsLoadingApp = (state) => state.booking.isLoadingApp;
const getIsFetchingDraft = (state) => state.booking.getDraft.isFetching;
const getIsFetchingDraftSuccessful = (state) => state.booking.getDraft.successful;
const getDraftCount = (state) => state.booking.getDraft.draftCount;
const getCustomer = (state) => state.booking.data.customer;
const getEndUser = (state) => state.booking.data.endUser;
const getEditingEndUser = (state) => state.booking.editingEndUser;
const getHasServices = (state) => state.booking.data.services.length > 0 || !isEmpty(state.booking.entities.services);
const getRouteIsFetching = (state) => state.booking.routes.isFetching;
const getLineIsFetching = (state) => getRouteIsFetching(state);
const getAddingService = (state) => state.booking.serviceAdd;
const getRouteList = (state) => {
    const { entities, routes } = state.booking;

    return routes.list.map(id => entities.routes[id]);
};
const getLineList = (state) => getRouteList(state)
const getRoute = (state) => {
    if(!isEmpty(state.booking.serviceAdd.data.route)){
        return state.booking.serviceAdd.data.route;
    } else if(!isEmpty(state.map.hike)){
        return state.map.hike
    }
    return null;
}
const getHasRoute = state => {
    const route = getRoute(state);

    return !isUndefined(route) && !isEmpty(route);
};
const getHasLine = state => getHasRoute(state);
const getServiceType = (state) => state.booking.serviceAdd.serviceType;
const getEditingService = state => {
    const { editingService, entities } = state.booking;

    if (null == editingService) {
        return null;
    }

    const service = entities.services[editingService]
    return {
        ...service,
        items: service.items.map(itemId =>{
            return entities.items[itemId]
        }),
    };
};

const getBooking = (state) => {
    const { data, entities } = state.booking;
    const { services } = data;
    return {
        ...data,
        services: services.map(serviceId => {
            const service = entities.services[serviceId];

            return {
                ...service,
                items: service.items.map(itemId => entities.items[itemId])
            }
        })
    };
};

const getIsSubmitting = (state) => state.booking.submit.isLoading;
const getIsSavingDraft = (state) => state.booking.saveDraft.isLoading;
const getShowSubmit = (state) => state.booking.submit.showForm;
const getShowServices = (state) => state.booking.serviceAdd.showServices;
const getIsValid = (state) => state.booking.submit.isValid;
const getAreTermsReaded = (state) => state.booking.submit.termsReaded;

const getServiceIsEditing = (state, service) => {
    const { editingService } = state.booking;

    return service.id == editingService;
};

const getHasEditingItem = (state) => null !== state.booking.editingItem;

const getEditingItem = (state) => state.booking.entities.items[state.booking.editingItem];

const getPreviousEditingItem = (state) => {

    let currentItemId = state.booking.editingItem
    const { editingService, entities } = state.booking;

    if (null == editingService || !currentItemId) {
        return null;
    }
    const service = entities.services[editingService]
    let index = service.items.indexOf(currentItemId);

    if(service.items[index-1]){
        let nextItemId = service.items[index-1]
        return entities.items[nextItemId]
    }
}

const getNextEditingItem = (state) => {

    let currentItemId = state.booking.editingItem
    const { editingService, entities } = state.booking;

    if (null == editingService || !currentItemId) {
        return null;
    }
    const service = entities.services[editingService]
    let index = service.items.indexOf(currentItemId);

    if(service.items[index+1]){
        let nextItemId = service.items[index+1]
        return entities.items[nextItemId]
    }
}

const getItemIsEditing = (state, item) => {
    const { editingItem } = state.booking;

    return item.id == editingItem;
};

const getIsSubmitSuccessful = state => state.booking.submit.successful;
const getIsSaveDraftSuccessful = state => state.booking.saveDraft.successful;
const getReference = state => state.booking.data.reference;

const getShowMap = state => {

    if(state.booking.editedService
        || (!state.booking.editedService && !state.booking.submit.showForm)){
        return true;
    }
    return false;
}

const isEditing = state => {
    return state.booking.booking.serviceAdd.requestData != false || state.booking.booking.editingService != null
}

const isUpdating = state => {
    return state.booking.booking.isUpdating
}

const getStage = state => state.booking.currentStage

const getDefaultDataFromState = (state) => {
    const {services} = state.booking.entities;
    const lastService = services[last(Object.keys(services))]
    return {
        route: lastService.route,
        hike: lastService.hike
    }
}

export {
    getIsLoadingApp,
    getCustomer,
    getEndUser,
    getEditingEndUser,
    getHasServices,
    getRouteIsFetching,
    getLineIsFetching,
    getRouteList,
    getAddingService,
    getRoute,
    getHasRoute,
    getHasLine,
    getLineList,
    getServiceType,
    getEditingService,
    getPreviousEditingItem,
    getNextEditingItem,
    getBooking,
    getShowSubmit,
    getIsSubmitting,
    getServiceIsEditing,
    getEditingItem,
    getItemIsEditing,
    getIsSubmitSuccessful,
    getIsValid,
    getAreTermsReaded,
    getReference,
    getHasEditingItem,
    getShowMap,
    isEditing,
    isUpdating,
    getIsSavingDraft,
    getIsSaveDraftSuccessful,
    getShowServices,
    getStage,
    getDefaultDataFromState,
    getIsFetchingDraft,
    getIsFetchingDraftSuccessful,
    getDraftCount
};
